import { useState } from "react";
import axios from "axios";
import { useEffect } from "react";
import { getDefualtStreamsApiPermissions } from "../../../apiclients/streamsapi_bridge";

// const PERMISSIONS_CONFIG = [
//   { id: 5, key: "read_account", label: "Read Account Info", desc: "Access essential account details, including user and group information." },
//   { id: 9, key: "outbound_sms", label: "Outbound SMS", desc: "Easily send SMS messages to phone numbers directly from your account." },
//   { id: 10, key: "Inbound_SMS", label: "Inbound SMS", desc: "Receive and process incoming SMS messages via webhook notifications", requiresWebhook: true },
//   { id: 6, key: "CTC", label: "Click-to-Call (CTC)", desc: "Enable click-to-call functionality and receive call event notifications", requiresWebhook: true },
//   { id: 1, key: "read_recordings", label: "Read Call Recordings", desc: "Access and download call recording files from your account" },
//   { id: 2, key: "read_cdr", label: "Read CDR", desc: "View detailed call records and download associated call recording files." },
//   { id: 7, key: "write_recordings", label: "Write Call Recordings", desc: "Delete unwanted call recordings from your account" },
// ];

export const StreamsPermissions = (props) => {
  const [url, setUrl] = useState("");
  const [permissionArray, setPermissionArray] = useState([]);


  const getAppPermissions =async ()=>{
    try {
        console.log("getDefualtCallBackURLS :: ")
        const serverResponse = await getDefualtStreamsApiPermissions();
        if (serverResponse.ok) {
            const responseData = await serverResponse.json();
            console.log("[saveApp] App created successfully:", JSON.stringify(responseData));
            const PERMISSIONS_CONFIG = responseData.permissionArray.map((item) => {
                // Generate a clean key name
                const key = item.value.replace(" ","_")
              
                // Default descriptions (can be customized per feature)
                const defaultDescriptions = {
                  "read call recordings": "Access and download call recording files from your account.",
                  "read cdr": "View detailed call records and download associated call recording files.",
                  "read account info": "Access essential account details, including user and group information.",
                  "ctc": "Enable click-to-call functionality and receive call event notifications.",
                  "write call recordings": "Delete unwanted call recordings from your account.",
                  "outbound sms": "Easily send SMS messages to phone numbers directly from your account.",
                  "inbound sms": "Receive and process incoming SMS messages via webhook notifications.",
                  "outbound fax": "Easily send fax documents to recipients directly from your account.",
                  "inbound fax":"Receive and process incoming fax documents via webhook notifications."
                };
              
                const webhookConfig = {
                        "inbound sms": { show: true, required: true },
                        "ctc": { show: true, required: true },
                        "inbound fax": { show: true, required: true },
                        "outbound sms": { show: true, required: false }, //  OPTIONAL
                    };

                    const config = webhookConfig[item.value.toLowerCase()] || {};

              
                return {
                        id: item.id,
                        key,
                        label: item.value,
                        desc: defaultDescriptions[item.value.toLowerCase()] || "No description available.",
                        ...(config.show ? { requiresWebhook: true } : {}),
                        ...(config.required !== undefined ? { webhookRequired: config.required } : {}),
                    };
              });
                const SORTED_PERMISSIONS = PERMISSIONS_CONFIG.sort((a, b) =>
                    a.label.localeCompare(b.label)
                );

                  setPermissionArray(SORTED_PERMISSIONS)

              // setPermissionArray(PERMISSIONS_CONFIG)
              
        } else {
            setPermissionArray([]);
        }
    } catch (error) {
        console.error("getDefualtCallBackURLS:", error);
    }
}
  const testWebhook = async () => {
    if (!url) {
      alert("Please enter a valid URL ");
      return;
    }
    try {
      const res = await axios.post(url);
      if (res.status === 200) {
        alert("Success  Webhook is valid");
      }
    } catch (err) {
      alert("Please enter a valid URL");
    }
  }

  useEffect(()=>{
    getAppPermissions()
  },[])

  useEffect(() => {
  if (props.selectedPermissions?.length > 0) {
    props.clearErrors("permissionsValidation");
  } else {
    props.setError("permissionsValidation", {
      type: "manual",
      message: "Select at least one permission",
    });
  }
}, [props.selectedPermissions, props.clearErrors, props.setError]);

  return (
    <div className="form-section">
      <p className="section-title"> <b>Permissions Configuration</b> <span style={{ color: "red" }}>*</span></p>
      <p className="section-description">
        Select the permissions your application needs. Some permissions require webhook endpoints.
      </p>
      <div className="mb-3"> 
        <div className="info-alert m-0">
          <span className="info-icon">ℹ️</span>
          <div className="info-content">
            <strong>Webhook Required:</strong> Inbound SMS, Inbound FAX and CTC permissions require webhook URLs to
            receive real-time events. You'll need to configure these endpoints below.
          </div>
        </div>
        {props.errors.permissionsValidation && (
          <div className="text-danger mt-2">
            {props.errors.permissionsValidation.message}
          </div>
        )}
      </div>

      <div className="permissions-list">
        {permissionArray.map((perm) => (
          <div key={perm.id} className="permission-item">
            <label className="permission-checkbox">
              <input
                type="checkbox"
                value={perm.key}
                checked={props.selectedPermissions?.some(p => p.app_permission_id === perm.id)}
                onChange={() => {
                  props.togglePermission(perm.id);
                }}
              />
              <div className="permission-content">
                <div className="permission-header">
                  <span className="permission-label">{perm.label}</span>
                  {perm.requiresWebhook &&
                    perm.label.toLowerCase() !== "outbound sms" && (
                      <span className="webhook-badge">Webhook Required</span>
                    )}
                </div>
                <div className="permission-description">{perm.desc}</div>
              </div>
            </label>

            {/* Show webhook config if required & selected */}
            {perm.requiresWebhook && props.selectedPermissions?.some(p => p.app_permission_id === perm.id) && (
              <div className="webhook-config">
                <div className="webhook-field">
                   <label className="webhook-label">
                    {perm.label} Webhook URL
                    {perm.webhookRequired ? (
                      <span className="required-asterisk">*</span>
                    ) : (
                      <span className="text-muted ms-1">(Optional)</span>
                    )}
                  </label>

                  <div className="webhook-input-group">
                    <input

                      type="url"
                      className="webhook-input pe-2"
                      placeholder={`https://your-domain.com/webhooks/${perm.key}`}
                      defaultValue={props.apiUrls[perm.key]}
                      {
                      ...props.register(`api_urls.${perm.key}`, {
                        required: perm.webhookRequired
                          ? `${perm.label} WebHook URL is required`
                          : false,
                        pattern: {
                          value: /^(((https):\/\/)(([a-zA-Z0-9-_\.]+[\.][A-Za-z0-9:]+))(\/[a-zA-Z0-9-_\.]*)*)(([\?]?)([a-zA-Z0-9-_\.&=@%\(\)]+)?)$/,
                          message: "Please Enter valid WebHook URL"
                        },
                        onChange: (e) => props.handleWebhookChange(perm.key, e.target.value),
                      })
                      }
                    />
                    {props.errors.api_urls?.[perm.key] && (
                      <div className="text-danger small mt-1">
                        {props.errors.api_urls?.[perm.key].message}
                      </div>
                    )}
                    {/* {props.dirtyFields.api_urls?.[perm.key] && (
                      <button type="button" class="test-button" onClick={testWebhook}>Test Webhook</button>
                    )
                    }                   */}
                    </div>
                  <div className="webhook-help">
                    This endpoint will receive POST requests for {perm.label} events.
                  </div>
                </div>
              </div>
            )}
          </div>
        ))}
        
          {/* <input
          type="hidden"
          {...props.register("permissionsValidation", {
            validate: () =>
              props.selectedPermissions?.length > 0 || "Select at least one permission",
          })}
        />
         */}

        
      </div>
    </div>
  );
};
